module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 7.35ca5ddd.png";